module.exports = __webpack_public_path__ + "static/img/daizhen.3b41075.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/daizhen.png
// module id = fjnH
// module chunks = 2